import Job from './Job'

export default Job
